
import {h} from "preact";
import style from "./Summary.module.css";
import {BaseItem, withLength, withWeight} from "../../file/File";
import classNames from "classnames";
import sumPartsByLength from "../sum/partsByLength";
import {Link} from "preact-router/match";

export type PartsByLengthProps = {
  part: string,
  interval: string,
  duration: number,
  dates: [number, number][],
  items: BaseItem[][],
  options?: string
  tabs: ({
    key: string,
    items: BaseItem[]
  } | null)[]
}


export const PartsByLength = (props: PartsByLengthProps) => {
  const {part, items, interval, duration, tabs=[], dates, options=""} = props;

  return <tr>
    <th class={classNames([style.name])}>{part}</th>
    {items.map((i, k) =>
      <td key={k} class={classNames([style.number])}>
        <Link href={`/materials/length/${encodeURIComponent(part)}/?start=${dates[k][0]}&interval=${interval}&duration=1${options}`}>
          {sumPartsByLength(part, i) }
        </Link>
      </td>)}
    <td class={classNames([style.number])}>
      <Link href={`/materials/length/${encodeURIComponent(part)}/?start=${dates[0][0]}&interval=${interval}&duration=${duration}${options}`}>
        { sumPartsByLength(part, items.reduce((acc, cur) => [...acc, ...cur])) }
      </Link>
    </td>
    {tabs.map(k => {
        if (k == null) return null;
        return <td key={k} className={classNames([style.number, style.tab])}>
          <Link
            href={`/materials/${k.key}/length/${encodeURIComponent(part)}/?start=${dates[0][0]}&interval=${interval}&duration=${duration}`}>
            {sumPartsByLength(part, k.items)}
          </Link>
        </td>
      }
    )}
  </tr>
}
